import { ACTIONS_MACHINE_MODEL } from '../_constants/machineModel.constants';

const initialState = {
  byId: {},
};

export function machineModelReducer(
  state = initialState,
  action
) {
  switch (action.type) {
    case ACTIONS_MACHINE_MODEL.INVALIDATE: {
      return {
        ...initialState,
      };
    }

    case ACTIONS_MACHINE_MODEL.DELETE:
    {
      const currentById = { ...state.byId };
      delete currentById[Object.keys(action.byId)[0]];

      return {
        ...state,
        byId: currentById,
      };
    }

    case ACTIONS_MACHINE_MODEL.RECEIVE: {
      return {
        ...state,
        byId: { ...state.byId, ...action.byId },
      };
    }

    default:
      return state;
  }
}

export default machineModelReducer;
